import { render } from "./ListeCompagnie.vue?vue&type=template&id=60dddb68&ts=true"
import script from "./ListeCompagnie.vue?vue&type=script&lang=ts"
export * from "./ListeCompagnie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__